import axios, { AxiosError, AxiosResponse } from 'axios';

export function startupConfigureHttpUnauth() {
    axios.interceptors.request.use(function setupAxiosRequest(config) {
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        config.headers['X-Language'] = window.app.config.language;

        return config;
    });

    axios.interceptors.response.use(
        function handleAxiosRequestResponse(response: AxiosResponse) {
            return response;
        },
        function handleAxiosRequestReject(axiosError: AxiosError) {
            throw axiosError;
        }
    );

    $.ajaxSetup({
        beforeSend: function setupJqueryAjaxBeforeSend(xhr) {
            xhr.setRequestHeader('X-Language', window.app.config.language);
        },
        complete: function handleJqueryAjaxComplete(xhr) {
            return xhr;
        }
    });
}
